import $ from "jquery";

$(document).ready(function() {

  function toggleAccordion() {
    const newsItems = $(".js-newsList .newsList__item");
    const newsMoreBtn = $(".js-newsMoreBtn");
    const itemsToShow = 3;
    let expanded = false;
    // newsItems.slice(itemsToShow).addClass("newsList__item--hidden")
    newsItems.slice(itemsToShow).hide()
    if (newsItems.slice(itemsToShow).length === 0) {
      newsMoreBtn.hide();
    }
    newsMoreBtn.on("click", function () {
      if (!expanded) {
        newsItems.slice(itemsToShow).slideDown(500)
        newsMoreBtn.text("閉じる");
      } else {
        newsItems.slice(itemsToShow).slideUp(500)
        newsMoreBtn.text("さらにお知らせを表示する");
      }
      expanded = !expanded;
    });
  }

  // 初期ロード時に呼び出す
  toggleAccordion();

});
